import store from '@/store';

import { LOG_ACTIVITY } from '@/store/actions/activity.actions';
import { modules } from '@/common/utils/modules';
import ActivityService from '@/common/services/activity.service';

export const ArticleViewed = (to, from, next) => {
  const moduleId = Object.keys(modules).find(key => modules[key] === process.env.VUE_APP_MODULE);

  store.dispatch(LOG_ACTIVITY, {
    activityType: ActivityService.ACTIVITY_TYPES.ARTICLE.VIEWED,
    activityData: {
      slug: to.params.article,
      moduleId: parseInt(moduleId)
    }
  });

  return next();
};
